import React, { useState, useEffect } from "react";
import { Button } from "./button";
import { Input } from "./input";

export const EditDescriptionModal = ({
  open,
  onClose,
  onSave,
  initialDescription = "",
  initialName = "",
  isLoading = false,
}) => {
  const [description, setDescription] = useState(initialDescription);
  const [name, setName] = useState(initialName);

  // Update fields when modal opens with new initial values
  useEffect(() => {
    if (open) {
      setDescription(initialDescription);
      setName(initialName);
    }
  }, [open, initialDescription, initialName]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isLoading) {
      onSave && onSave(description, name);
    }
  };

  const handleClose = () => {
    if (!isLoading) {
      setDescription("");
      setName("");
      onClose();
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-xl">
        <h3 className="text-lg font-semibold mb-4">Edit File Details</h3>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              File Name
            </label>
            <Input
              className="w-full"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter file name..."
              disabled={isLoading}
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Description
            </label>
            <Input
              className="w-full"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter file description..."
              disabled={isLoading}
            />
          </div>
          <div className="flex justify-end gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={handleClose}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="bg-blue-500 text-white"
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
